import { API_HELPER } from "./ApiHelper";
import { setCartItems } from "../ReduxToolkit/Reducers/cart-slice";
import { API_WEB_URLS } from "../constants/constAPI";

export const fetchAndSyncCart = async (dispatch) => {
    const userDataStr = localStorage.getItem("userData");
    if (!userDataStr) return;
    
    try {
        const userData = JSON.parse(userDataStr);
        let userId = "0";
        let userToken = "token";
        
        const actualData = userData.data?.response?.[0] || userData.response?.[0] || userData[0] || userData;
        const parsedId = actualData.Id || actualData.id || actualData.UserId;
        if (parsedId && String(parsedId).trim() !== "") {
            userId = String(parsedId).trim();
        }
        const parsedToken = actualData.Token || actualData.token || actualData.UserToken;
        if (parsedToken && String(parsedToken).trim() !== "") {
            userToken = String(parsedToken).trim();
        }

        if (userId !== "0") {
            const url = `${API_WEB_URLS.BASE}Cart/${userId}/${userToken}`;
            const response = await API_HELPER.apiGET(url);
            
            if (response?.success && response?.data?.list) {
                const apiItems = response.data.list;
                const formattedItems = apiItems.map(item => ({
                    id: String(item.ItemDesignId),
                    cartItemId: item.CartItemId,
                    name: item.ItemName || "",
                    price: item.Price || 0,
                    quantity: item.Qty || 1,
                    image: [item.DesignPhoto || ""],
                    shortDescription: item.ShortDescription || "",
                    fullDescription: item.FullDescription || "",
                    stock: 100 // Default fallback stock since it's not provided
                }));
                
                // Update redux store
                dispatch(setCartItems(formattedItems));
            }
        }
    } catch (e) {
        console.error("Error fetching user cart:", e);
    }
};
